// s101 (D496, Dr. Rami 2026-10-13): the rules of signing the physician's OWN agreement WITH Orella's.
// Pure (no imports): the gate check-physician-agreement-app runs it.
//   ★ ONE signature, TWO records: patientAgreement (Orella's) gains `practiceAgreement` - the physician's
//     version, as shown, with that signature. Patients keep the version they signed.
//   ★ The signature is bound to the agreement it was given for: switching to a doctor with a different
//     agreement (or none) asks for a new signature.

/** Is this agreement the physician's uploaded PDF? */
export const practiceIsPdf = (a) => !!(a && Array.isArray(a.sections) && a.sections.some((s) => s && s.kind === 'pdf'))
export const practicePdfEntry = (a) => (a && Array.isArray(a.sections) ? a.sections.find((s) => s && s.kind === 'pdf') : null) || null

/** The key a signature was given for: the template id + version, or 'none'. */
export const practiceSignKey = (a) => (a && a.templateId ? `${a.templateId}@${a.version || ''}` : 'none')

/** May "Sign" be pressed? Ink, and every agreement shown is ticked. */
export function canAcceptSignature({ hasInk, practice, agreeOrella, agreePractice }) {
  if (!hasInk) return false
  if (!practice) return true
  return !!(agreeOrella && agreePractice)
}

/** The record stored beside Orella's: a snapshot of what the patient was shown (no live links). */
export function practiceAgreementRecord(a, signature, nowIso) {
  if (!a || !a.templateId || !signature) return null
  return {
    signed: true,
    signedAt: nowIso,
    signature,
    method: 'app',
    templateId: a.templateId,
    agreementVersion: a.version,
    doctorId: a.doctorId,
    title: a.title,
    sections: (a.sections || []).map((s) => {
      if (!s || typeof s !== 'object') return s
      const { url, ...rest } = s // eslint-disable-line no-unused-vars
      return rest
    }),
    effectiveDate: a.effectiveDate || null,
  }
}

/** A signature already given must be asked for again when the agreement on screen is not the one signed. */
export const signatureStillValid = (signedForKey, current) => signedForKey === practiceSignKey(current)
